const ADMIN = '/api/admin'
const BANNER_ADMIN = '/api/banner/admin'
const CHAIN_STORE_ADMIN = '/api/chain_store/admin'

export const API_PATHS = Object.freeze({
    // 账户管理
    ACCOUNT_UNFREEZE_LIST: `${ADMIN}/account/customer/password/unfreeze/record/find/list`,
    ACCOUNT_CANCELLATION_LIST: `${ADMIN}/account/customer/logout/record/find/list`,
    ACCOUNT_RESET_PASSWORD_LIST: `${ADMIN}/account/customer/password/reset/record/find/list`,

    // Banner管理
    BANNER_CLASS_LIST: `${BANNER_ADMIN}/class/find/list`,
    BANNER_LIST: `${BANNER_ADMIN}/find/list`,
    BANNER_ASPECT_RATIO_LIST: `${BANNER_ADMIN}/aspect_ratio/find/list`,

    // 门店管理
    CHAIN_STORE_LIST: `${CHAIN_STORE_ADMIN}/find/list`,
    CHAIN_STORE_BRANCH_LIST: `${CHAIN_STORE_ADMIN}/branch/find/list`,
})